import { CONTENT_TYPE_ID, FEEDBACKS_GEOMETRY_TYPE_CODES } from '../../../constants';
export const getters = {
    getWebTheme: state => {
        return state.webTheme;
    },
    getWebThemeFeedback: state => {
        return state.feedbacks[0];
    },
    getWebThemeFeedbackType: (state, _getters) => {
        return _getters.getWebThemeFeedback?.data?.feedbackType?.contentTypeId;
    },
    getWebThemeHasFeedbackType: (state, _getters) => {
        return _getters.getWebThemeFeedbackType === CONTENT_TYPE_ID.FEEDBACK;
    },
    getWebThemeHasMetingenType: (state, _getters) => {
        return _getters.getWebThemeFeedbackType === CONTENT_TYPE_ID.MEASUREMENT;
    },
    getWebThemeFeedbackHasPointGeoOnly: (state, _getters) => {
        return _getters.getWebThemeHasFeedbackType && _getters.getWebThemeFeedback?.data?.geometryType === FEEDBACKS_GEOMETRY_TYPE_CODES.POINT;
    },
    getWebThemeParameters: state => {
        let webThemeParameters = { ...state.webThemeParameters };
        let center = webThemeParameters.center;
        // In case of no parameters in the URL: use the values from the API call
        if (state.webTheme?.data) {
            const searchParams = new URLSearchParams(state.webTheme.data.urlParameters);
            webThemeParameters.width = webThemeParameters.width || searchParams.get('w');
            webThemeParameters.height = webThemeParameters.height || searchParams.get('h');

            const zoom = webThemeParameters.zoom || searchParams.get('z');
            webThemeParameters.zoom = zoom && parseFloat(zoom.replace(',', '.'));

            center = center || searchParams.get('c');
        }

        webThemeParameters.center = center?.split(';')
            .map(coordinate => {
                return coordinate.replace(',', '.');
            })
            .map(parseFloat);

        const startedFromPortal = webThemeParameters.startedFromPortal;
        webThemeParameters.startedFromPortal = startedFromPortal?.toLowerCase() === 'y';

        return webThemeParameters;
    },
    getShowTableViewSmallDevices: (state, _getters) => {
        return !_getters.isMobile
            ? _getters.getWebTheme?.data?.showTableViewSmallDevices
            : false;

    }
};
